<template>
	<div class="policy-finder">
		<!-- Progress Bar -->
		<div class="progress-bar-container">
			<div
				class="progress-bar-fill"
				:style="{ width: progressPercentage + '%' }"
			></div>
		</div>

		<!-- Progress Title -->
		<div class="progress-title">
			<p>{{ currentStep + 1 }}/{{ parsedData.length }} - {{ parsedData[currentStep].title }}</p>
		</div>

		<!-- Conditional Form Steps -->
		<div v-if="currentStep === 0">
			<h2 class="step-title">{{ parsedData[0].question }}</h2>
			<p class='step-description'>{{ parsedData[0].description }}</p>
			<div class='ctas step-ctas'>
				<secondary-button
					v-for="(option, index) in parsedData[0].options"
					:key="index + '_0'"
					@click.native="nextStep(option.value)"
					:link="{'url': '#', 'target': '_self', 'title': option.label}"
					:label="option.label"
				></secondary-button>
			</div>
		</div>

		<div v-if="currentStep === 1">
			<h2 class="step-title">{{ parsedData[1].question }}</h2>
			<p class='step-description'>{{ parsedData[1].description }}</p>
			<div class='ctas step-ctas'>
				<secondary-button
					v-for="(option, index) in parsedData[1].options"
					:key="index + '_1'"
					@click.native="nextStep(option.value)"
					:link="{'url': '#', 'target': '_self', 'title': option.label}"
					:label="false"
				></secondary-button>
			</div>
		</div>

		<div v-if="currentStep === 2 && !selectedOptions.includes('strataManaged')">
			<h2 class="step-title">{{ parsedData[2].question }}</h2>
			<p class='step-description'>{{ parsedData[2].description }}</p>
			<div class='ctas step-ctas'>
				<secondary-button
					v-for="(option, index) in parsedData[2].options"
					:key="index + '_2'"
					@click.native="nextStep(option.value)"
					:link="{'url': '#', 'target': '_self', 'title': option.label}"
					:label="false"
				></secondary-button>
			</div>
		</div>

		<div v-if="currentStep === 3 || (currentStep === 2 && selectedOptions.includes('strataManaged'))">
			<!-- <p class='step-description'>{{ parsedData[3].description }}</p> -->
			<div
				class='option-wrapper'
				v-if='parsedData[3].options'
			>
				<div
					v-for="(option, index) in parsedData[3].options"
					:key="index"
				>
					<img
						v-if="isOptionValid(option.value) && option.icon"
						:src='option.icon'
						:alt='option.label'
					/>

					<h3
						v-if="isOptionValid(option.value) && option.label"
						v-html='option.label'
					></h3>
					<p
						v-if="isOptionValid(option.value) && option.description"
						v-html='option.description'
					></p>

					<div
						v-if="isOptionValid(option.value)"
						class='ctas'
					>

						<primary-button
							:link="option.primary_cta"
							:label="'Get a Quote'"
						></primary-button>

						<secondary-button
							v-for="(cta, index) in option.secondary_ctas"
							:key='index'
							:link="cta.secondary_cta"
							:label="cta.secondary_cta.title"
						></secondary-button>

					</div>
				</div>
			</div>

		</div>

		<div class='ctas bottom'>
			<tertiary-button
				v-if="currentStep > 0 && currentStep != 3"
				@click.native="prevStep"
				:link="{'url': '#', 'target': '_self', 'title': 'Back'}"
				:label="'Back'"
				:type="'back'"
			></tertiary-button>

			<secondary-button
				v-if="currentStep === 3"
				@click.native="resetForm"
				:link="{'url': '#', 'target': '_self', 'title': 'Reset Quiz'}"
				:label="'Reset Quiz'"
			></secondary-button>
		</div>

	</div>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import TertiaryButton from './TertiaryButton.vue';

export default {
	data() {
		return {
			currentStep: 0,
			selectedOptions: [],
			steps: [
				{
					title: 'Rental Period',
					question:
						'Is the property being rented out on a long term or short term basis?',
					description:
						'Choose whether the property is being rented on a long-term (6 months or more) or short-term basis (less than 6 months).',
					options: [
						{ label: 'Long term (6 months +)', value: 'longTerm' },
						{ label: 'Short term (less than 6 months)', value: 'shortTerm' },
					],
				},
				{
					title: 'Property Type',
					question:
						'Is the property free standing? Or strata managed unit/apartment?',
					description:
						'Select whether the property is a free-standing house or a strata-managed unit or apartment.',
					options: [
						{ label: 'Strata Managed', value: 'strataManaged' },
						{ label: 'Free Standing', value: 'freeStanding' },
					],
				},
				{
					title: 'Is Insured?',
					question: 'Is the building insured?',
					description: 'Confirm whether the building is currently insured.',
					options: [
						{ label: 'Yes', value: 'buildingInsured' },
						{ label: 'No', value: 'notInsured' },
					],
				},
				{
					title: 'Complete',
					question: 'Final Options',
					description:
						'Here are the available insurance options based on your selections.',
					options: [
						{
							label: 'Landlord insurance',
							value: 'landlordInsurance',
							description:
								'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
							primary_cta: {
								url: '/#quote',
								title: 'Get a Quote',
								target: '_blank',
							},
							secondary_cta: {
								url: '/#cta',
								title: 'About Landlord Insurance',
								target: '_self',
							},
							icon: false,
						},
						{
							label: 'Combined landlord + building',
							value: 'combinedLandlordBuilding',
							description:
								'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
							primary_cta: {
								url: '/#quote',
								title: 'Get a Quote',
								target: '_blank',
							},
							secondary_cta: {
								url: '/#cta',
								title: 'About Combined landlord + building',
								target: '_self',
							},
							icon: false,
						},
						{
							label: 'Holiday Rental Cover',
							value: 'holidayRentalCover',
							description:
								'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
							primary_cta: {
								url: '/#quote',
								title: 'Get a Quote',
								target: '_blank',
							},
							secondary_cta: {
								url: '#cta',
								title: 'About Holiday Rental Cover',
								target: '_self',
							},
							icon: false,
						},
						{
							label: 'Combined holiday rental + building',
							value: 'combinedHolidayRentalBuilding',
							description:
								'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
							primary_cta: {
								url: '/#quote',
								title: 'Get a Quote',
								target: '_blank',
							},
							secondary_cta: {
								url: '/#cta',
								title: 'About Combined holiday rental + building',
								target: '_self',
							},
							icon: false,
						},
					],
				},
			],
		};
	},
	props: {
		data: {},
	},

	computed: {
		progressPercentage() {
			return ((this.currentStep / (this.parsedData.length - 1)) * 100).toFixed(
				2,
			);
		},

		parsedData() {
			if (this.data) {
				return JSON.parse(this.data);
			} else {
				return null;
			}
		},
	},
	methods: {
		nextStep(option) {
			this.selectedOptions.push(option);
			if (option === 'strataManaged') {
				this.currentStep += 2;
			} else {
				this.currentStep++;
			}
		},
		prevStep() {
			const lastSelectedOption = this.selectedOptions.pop();
			if (lastSelectedOption === 'strataManaged') {
				this.currentStep -= 2;
			} else {
				this.currentStep--;
			}
		},
		resetForm() {
			this.currentStep = 0;
			this.selectedOptions = [];
		},
		isOptionValid(option) {
			// Check if the option should be displayed based on selected options
			if (
				(option === 'landlordInsurance' &&
					this.selectedOptions.includes('longTerm') &&
					(this.selectedOptions.includes('strataManaged') ||
						(this.selectedOptions.includes('freeStanding') &&
							this.selectedOptions.includes('buildingInsured')))) ||
				(option === 'combinedLandlordBuilding' &&
					this.selectedOptions.includes('longTerm') &&
					this.selectedOptions.includes('freeStanding') &&
					this.selectedOptions.includes('notInsured')) ||
				(option === 'holidayRentalCover' &&
					this.selectedOptions.includes('shortTerm') &&
					(this.selectedOptions.includes('strataManaged') ||
						(this.selectedOptions.includes('freeStanding') &&
							this.selectedOptions.includes('buildingInsured')))) ||
				(option === 'combinedHolidayRentalBuilding' &&
					this.selectedOptions.includes('shortTerm') &&
					this.selectedOptions.includes('freeStanding') &&
					this.selectedOptions.includes('notInsured'))
			) {
				return true;
			}
			return false;
		},
	},
	components: { PrimaryButton, SecondaryButton, TertiaryButton },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.policy-finder {
	max-width: 100%;
	margin: 0 auto;
	text-align: center;
}

.progress-bar-container {
	position: relative;
	width: 100%;
	height: 10px;
	background-color: var(--light-grey);
	border-radius: 5px;
	margin-bottom: 10px;
	overflow: hidden;
}

.progress-bar-fill {
	height: 100%;
	background-color: var(--cobalt);
	width: 0%;
	transition: width 0.4s ease;
}

.step-title {
	text-align: left;
}

h2 {
	margin: 0 0 33px;
}

.option-wrapper {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	border: 1px solid var(--medium-grey);
	background: var(--white);
	border-radius: 15px;
	padding: 33px;
	margin-bottom: 33px;

	> div {
		width: 100%;
		text-align: left;
	}

	img {
		display: flex;
		margin: 0 0 33px;
	}

	h3 {
		margin: 0 0 33px;
	}

	p {
		margin: 0 0 33px;
		font: normal normal 400 14px/18px var(--primary-font-family);
	}
}

.step-description {
	text-align: left;
	font: normal normal 400 14px/18px var(--primary-font-family);
	margin-bottom: 33px;
}

.ctas {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: 12px;

	/* &.step-ctas {
		@media (max-width: $mobile-xl) {
			flex-direction: column;

			> a {
				width: max-content;
			}
		}
	} */

	&.bottom {
		margin-top: 36px;
	}
}

.progress-title {
	margin-bottom: 33px;

	p {
		font: normal normal 700 14px/18px var(--primary-font-family);
		text-transform: uppercase;
		text-align: left;
	}
}

.navigation-buttons {
	margin-top: 33px;
}
</style>
